if($s.media.isMediumDown){
  if (navigator.share) {
    document.querySelector('.custom-share-wrap').style.display = "none";
    document.querySelector('.native-share-wrap').style.display = "block";
    document.querySelector(".native-share").addEventListener("click", function() {
      navigator.share({
        title: document.title,
        url: this.dataset.url
      }).then(() => {
        console.log('Thanks for sharing!');
      })
      .catch(console.error);
    }, false);
  } else {
   document.querySelector('.native-share-wrap').style.display = "none";
  }
}

document.querySelector('.btn.copy-url').addEventListener('click', (e) => {
  e.preventDefault();
  navigator.clipboard.writeText(e.target.href.toString());
});